import { render } from "./Authorized.vue?vue&type=template&id=44332740"
import script from "./Authorized.vue?vue&type=script&lang=js"
export * from "./Authorized.vue?vue&type=script&lang=js"
script.render = render

export default script